import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import reasonsD144dc from './reasons'
/**
* @see \App\Http\Controllers\PrismaController::snapshot
* @see Http/Controllers/PrismaController.php:65
* @route '/projects/{project}/prisma/snapshot'
*/
export const snapshot = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: snapshot.url(args, options),
    method: 'get',
})

snapshot.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/prisma/snapshot',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PrismaController::snapshot
* @see Http/Controllers/PrismaController.php:65
* @route '/projects/{project}/prisma/snapshot'
*/
snapshot.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return snapshot.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PrismaController::snapshot
* @see Http/Controllers/PrismaController.php:65
* @route '/projects/{project}/prisma/snapshot'
*/
snapshot.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: snapshot.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::snapshot
* @see Http/Controllers/PrismaController.php:65
* @route '/projects/{project}/prisma/snapshot'
*/
snapshot.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: snapshot.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PrismaController::snapshot
* @see Http/Controllers/PrismaController.php:65
* @route '/projects/{project}/prisma/snapshot'
*/
const snapshotForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: snapshot.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::snapshot
* @see Http/Controllers/PrismaController.php:65
* @route '/projects/{project}/prisma/snapshot'
*/
snapshotForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: snapshot.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::snapshot
* @see Http/Controllers/PrismaController.php:65
* @route '/projects/{project}/prisma/snapshot'
*/
snapshotForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: snapshot.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

snapshot.form = snapshotForm

/**
* @see \App\Http\Controllers\PrismaController::reasons
* @see Http/Controllers/PrismaController.php:112
* @route '/projects/{project}/prisma/reasons'
*/
export const reasons = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reasons.url(args, options),
    method: 'get',
})

reasons.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/prisma/reasons',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PrismaController::reasons
* @see Http/Controllers/PrismaController.php:112
* @route '/projects/{project}/prisma/reasons'
*/
reasons.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return reasons.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PrismaController::reasons
* @see Http/Controllers/PrismaController.php:112
* @route '/projects/{project}/prisma/reasons'
*/
reasons.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reasons.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::reasons
* @see Http/Controllers/PrismaController.php:112
* @route '/projects/{project}/prisma/reasons'
*/
reasons.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: reasons.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PrismaController::reasons
* @see Http/Controllers/PrismaController.php:112
* @route '/projects/{project}/prisma/reasons'
*/
const reasonsForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reasons.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::reasons
* @see Http/Controllers/PrismaController.php:112
* @route '/projects/{project}/prisma/reasons'
*/
reasonsForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reasons.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::reasons
* @see Http/Controllers/PrismaController.php:112
* @route '/projects/{project}/prisma/reasons'
*/
reasonsForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reasons.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

reasons.form = reasonsForm

/**
* @see \App\Http\Controllers\PrismaController::exportMethod
* @see Http/Controllers/PrismaController.php:160
* @route '/projects/{project}/prisma/export'
*/
export const exportMethod = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(args, options),
    method: 'get',
})

exportMethod.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/prisma/export',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PrismaController::exportMethod
* @see Http/Controllers/PrismaController.php:160
* @route '/projects/{project}/prisma/export'
*/
exportMethod.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return exportMethod.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PrismaController::exportMethod
* @see Http/Controllers/PrismaController.php:160
* @route '/projects/{project}/prisma/export'
*/
exportMethod.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::exportMethod
* @see Http/Controllers/PrismaController.php:160
* @route '/projects/{project}/prisma/export'
*/
exportMethod.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: exportMethod.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PrismaController::exportMethod
* @see Http/Controllers/PrismaController.php:160
* @route '/projects/{project}/prisma/export'
*/
const exportMethodForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::exportMethod
* @see Http/Controllers/PrismaController.php:160
* @route '/projects/{project}/prisma/export'
*/
exportMethodForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::exportMethod
* @see Http/Controllers/PrismaController.php:160
* @route '/projects/{project}/prisma/export'
*/
exportMethodForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

exportMethod.form = exportMethodForm

const prisma = {
    snapshot: Object.assign(snapshot, snapshot),
    reasons: Object.assign(reasons, reasonsD144dc),
    export: Object.assign(exportMethod, exportMethod),
}

export default prisma